import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../core/Evented.js";

var e = /*#__PURE__*/function () {
  function e(_ref) {
    var _e = _ref.grabbableForEvent;

    _classCallCheck(this, e);

    this.events = new t(), this.interactive = !0, this.selectable = !1, this.cursor = null, this.grabbable = !0, this.grabbableForEvent = _e;
  }

  _createClass(e, [{
    key: "intersectionDistance",
    value: function intersectionDistance(t, _e2) {
      return 0;
    }
  }, {
    key: "attach",
    value: function attach() {}
  }, {
    key: "detach",
    value: function detach() {}
  }]);

  return e;
}();

export { e as DrawManipulator };